import { FormattingOperator } from '@ardoq/api-types';

interface AttributeComparatorProperties {
  [prop: string]: any;
  id: FormattingOperator;
  name: string;
  isIncluded: (value: any, filterValue: any) => boolean;
}
class AttributeComparator {
  id: FormattingOperator;
  name: string;
  label?: string;
  operator?: FormattingOperator;

  constructor(properties: AttributeComparatorProperties) {
    Object.assign(this, properties);
    this.id = properties.id;
    this.name = properties.name;
  }
  getLabel = () => this.label || this.operator;
  // eslint-disable-next-line @typescript-eslint/class-methods-use-this
  isIncluded = (value: any, filterValue: any) => {
    throw {
      name: 'Method not overridden!',
      message: 'Should be overridden in the Comparator to filter properly',
      value,
      filterValue,
    };
  };
}
export { AttributeComparator };
